/* eslint-disable eqeqeq */
import React from "react";
import {
  Table,
  Spin,
  DatePicker,
  Row,
  Col,
  Button,
  Input,
  Icon,
  Menu,
  Dropdown,
  Modal,
  Form,
  Empty,
  Alert, Typography
} from "antd";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { CdrService } from "../../services/cdr/CdrService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import CDRSwitchedCalls from "./CDRSwitchedCalls";
import Highlighter from "react-highlight-words";
import "./CDRTable.css";
import AudioPlayer from "../streaming/AudioPlayer";
import moment from "moment";
import { convertTZToLocalCDR } from "../general/DateTzHelper";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { Translation } from "react-i18next";
import i18next from "i18next";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
import { Constants } from "../../data/constants";
const { RangePicker } = DatePicker;
const { Text } = Typography;

class CDRTable extends React.Component {
  constants = new Constants();
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.props.context.setCurrentComponent("cdrs");
    this.cdrService = new CdrService();
    this.state = {
      searchText: "",
      isFetching: false,
      isExporting: false,
      visible: false,
      data: [],
      switchedData: [],
      file: null,
      url: "h",
      audio: null,
      play: false,
      from: null,
      to: null,
      isSelected: false,
      selectedData: [],
      columns: [],
      idsList: [],
      selectedCallRecordsId: [],
      selectedVoiceMailsId: [],
      allCallRecordsIds: [],
      allVoiceMailsIds: [],
      cdrHeaders: [
        "Cdr Id",
        "A Number",
        "Customer Name",
        "B Number",
        "Call Record",
        "Voicemail",
        "Start Time",
        "End Time",
        "Switched Time",
        "Call Result",
        "Call Duration",
        "Call Direction",
      ],
      cdrSwitchedHeaders: [
        "Cdr Id",
        "Username",
        "Switch Time",
        "Switching Status",
        "Call Status",
        "Answer Time",
        "End Time",
      ],
      showModal: false,
      fileName: "",
      operationKey: 0,
      searchedColumn: "",
      lang:
        this.props.context.curr_lang === "ar" &&
          this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  componentDidMount() {
    this.getAllCdrs();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async getAllCdrs() {
    try {
      this.setState({ isFetching: true });
      let from = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss")
        .toString();
      let to = moment().format("YYYY-MM-DD HH:mm:ss").toString();

      let data = await this.cdrService.getCdrsFromToStartDate(
        this.props.context.session_id,
        from,
        to
      );

      let idsTempList = [];
      let idsvoiceMailList = [];
      let formatedData = this.formatData(data);
      formatedData.forEach((item) => {
        if (item.isSwitched === "true" && item.callResult == "ANSWERED_BY_AGENT" && !item.isExpired) {
          idsTempList.push(item.cdrId);
        }

        if (item.hasVoiceMail) {
          if (this.constants.enableVoiceMailExpiration && !item.isExpired) {
            idsvoiceMailList.push(item.cdrId);
          } else {
            idsvoiceMailList.push(item.cdrId);
          }

        }
        // if (item.callResult === "ANSWERED_VOICEMAIL") {
        //   idsvoiceMailList.push(item.cdrId);
        // }
      });

      this.setState({
        data: formatedData,
        isFetching: false,
        from: from,
        to: to,
        allCallRecordsIds: idsTempList,
        allVoiceMailsIds: idsvoiceMailList,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  async getAllSwitchedCRD(from, to) {
    try {
      this.setState({ isExporting: true });

      let data = await this.cdrService.getAllSwitchedCRDDateService(
        this.props.context.session_id,
        from,
        to
      );
      this.setState({
        isExporting: false,
      });
      return data.ivrList;
    } catch (e) {
      handleError(e);
    }
  }

  async getSelectedSwitchedCRD(ids) {
    try {
      this.setState({ isExporting: true });
      let data = await this.cdrService.getSelectedSwitchedCRDDateService(
        this.props.context.session_id,
        ids
      );

      this.setState({
        isExporting: false,
      });
      return data.ivrList;
    } catch (e) {
      handleError(e);
    }
  }
  async downloadCdrFile(ids) {
    try {
      this.setState({ isExporting: true });
      let data = await this.cdrService.downloadCdrFiles(
        this.props.context.session_id,
        ids
      );
      this.setState({
        isExporting: false,
      });
      return data;
    } catch (e) {
      this.setState({
        isExporting: false,
      });
      handleError(e);
    }
  }
  async downloadCdrVoicemailFile(ids) {
    try {
      this.setState({ isExporting: true });
      let data = await this.cdrService.downloadCdrVoicemailFiles(
        this.props.context.session_id,
        ids
      );

      this.setState({
        isExporting: false,
      });
      return data;
    } catch (e) {
      this.setState({
        isExporting: false,
      });
      handleError(e);
    }
  }

  async onOk(dates) {
    try {
      this.setState({ isFetching: true });
      let data = await this.cdrService.getCdrsFromToStartDate(
        this.props.context.session_id,
        dates[0].format("YYYY-MM-DD HH:mm:ss").toString(),
        dates[1].format("YYYY-MM-DD HH:mm:ss").toString()
      );
      let idsTempList = [];
      let idsvoiceMailList = [];
      let formatedData = this.formatData(data);
      formatedData.forEach((item) => {
        if (item.isSwitched === "true" && item.callResult == "ANSWERED_BY_AGENT" && !item.isExpired) {
          idsTempList.push(item.cdrId);
        }

        if (item.hasVoiceMail) {
          if (this.constants.enableVoiceMailExpiration) {
            if(!item.isExpired) idsvoiceMailList.push(item.cdrId);
          } else {
            idsvoiceMailList.push(item.cdrId);
          }

        }
        // if (item.callResult === "ANSWERED_VOICEMAIL") {
        //   idsvoiceMailList.push(item.cdrId);
        // }
      });
      this.setState({
        data: formatedData,
        isFetching: false,
        from: dates[0].format("YYYY-MM-DD HH:mm:ss").toString(),
        to: dates[1].format("YYYY-MM-DD HH:mm:ss").toString(),
        allCallRecordsIds: idsTempList,
        allVoiceMailsIds: idsvoiceMailList,
      });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            this.setState({ searchedColumn: dataIndex });

            this.handleSearch(selectedKeys, confirm);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.setState({ searchedColumn: dataIndex });

            this.handleSearch(selectedKeys, confirm);
          }}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
              this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleOk = () => {
    this.setState({ showModal: false });
    this.handleMenuClick(
      this.state.operationKey,
      this.state.isSelected
        ? this.redefinedData(this.state.selectedData, this.state.cdrHeaders)
        : this.redefinedData(
          this.formatDataToExport(this.state.data),
          this.state.cdrHeaders
        ),
      this.state.fileName
    );
    this.myRef.current = "";
  };

  handleCancel = () => {
    this.setState({
      showModal: false,
    });
  };

  formatData(data) {
    const updated_data = [];
    if (data.ivrList === null) {
      return [];
    }

    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["cdrId"] = data.ivrList[i]["cdrId"];
      row["a"] = data.ivrList[i]["a"];
      row["b"] = data.ivrList[i]["b"];
      row["startTime"] = convertTZToLocalCDR(data.ivrList[i]["startTime"]);
      row["endTime"] = convertTZToLocalCDR(data.ivrList[i]["endTime"]);
      row["switchTime"] = data.ivrList[i]["isSwitched"]
        ? convertTZToLocalCDR(data.ivrList[i]["switchTime"])
        : "---";
      row["isSwitched"] = data.ivrList[i]["isSwitched"].toString();
      row["callResult"] = data.ivrList[i]["callResult"];
      row["customerName"] = data.ivrList[i]["fullname"]
        ? data.ivrList[i]["fullname"]
        : "---";
      row["callDuration"] = new Date(
        parseFloat(data.ivrList[i]["callDuration"]).toFixed(2) * 1000
      )
        .toISOString()
        .substr(11, 8);

      row["callDirection"] = data.ivrList[i]["callDirection"];
      row["hasVoiceMail"] = data.ivrList[i]["hasVoiceMail"];
      row['isExpired'] = this.isExpiredWithStartOfDay(convertTZToLocalCDR(data.ivrList[i]["startTime"]));
      updated_data.push(row);
    }
    return updated_data;
  }
  customExpandIcon(props) {
    if (props.expanded) {
      return (
        <Button
          icon="minus"
          size="small"
          className="custom_expand_button"
          onClick={(e) => {
            props.onExpand(props.record, e);
          }}
          disabled={props.record.isSwitched == "true" ? false : true}
        />
      );
    } else {
      return (
        <Button
          icon="plus"
          size="small"
          className="custom_expand_button"
          onClick={(e) => {
            props.onExpand(props.record, e);
          }}
          disabled={props.record.isSwitched == "true" ? false : true}
        />
      );
    }
  }

  handleMenuClick = async (e, data, fileName) => {
    if (e == 1 && this.state.isSelected == false) {
      let switchedData = await this.getAllSwitchedCRD(
        this.state.from,
        this.state.to
      );

      let redefinedSwitchedData = this.redefinedData(
        this.formatSwitchDataToExport(switchedData),
        this.state.cdrSwitchedHeaders
      );

      const zip = new JSZip();
      zip.file("CDR.csv", this.createCsvFile(data));

      zip.file("Switched.csv", this.createCsvFile(redefinedSwitchedData));
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, fileName + ".zip");
      });
    } else if (e == 1 && this.state.isSelected == true) {
      const zip = new JSZip();
      if (this.state.idsList.length != 0) {
        let switchedData = await this.getSelectedSwitchedCRD(
          this.state.idsList
        );

        let redefinedSwitchedData = this.redefinedData(
          this.formatSwitchDataToExport(switchedData),
          this.state.cdrSwitchedHeaders
        );

        zip.file("Switched.csv", this.createCsvFile(redefinedSwitchedData));
        zip.file("CDR.csv", this.createCsvFile(data));

        zip.generateAsync({ type: "blob" }).then(function (content) {
          saveAs(content, fileName + ".zip");
        });
      } else {
        this.createCsvFileDataNoSwitched(data, fileName);
      }
    } else if (e == 2 && this.state.isSelected == true) {
      this.createSelectedCdrZipFolder(data, fileName + ".zip");
    } else if (e == 2 && this.state.isSelected == false) {
      this.createAllCdrZipFolder(data, fileName + ".zip");
    }
  };

  createAllCdrZipFolder = async (data, name) => {
    const zip = new JSZip();
    let switchedData = await this.getAllSwitchedCRD(
      this.state.from,
      this.state.to
    );
    let redefinedSwitchedData = this.redefinedData(
      this.formatSwitchDataToExport(switchedData),
      this.state.cdrSwitchedHeaders
    );

    let callRecordsFiles = await this.downloadCdrFile(
      this.state.allCallRecordsIds
    );
    let voicemailsFiles = await this.downloadCdrVoicemailFile(
      this.state.allVoiceMailsIds
    );

    zip.file("CDR.csv", this.createCsvFile(data));
    zip.file("Switched.csv", this.createCsvFile(redefinedSwitchedData));
    zip.file("callRecords.zip", callRecordsFiles);
    zip.file("voicemails.zip", voicemailsFiles);

    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, name);
    });
  };

  createSelectedCdrZipFolder = async (data, name) => {
    const zip = new JSZip();
    if (this.state.idsList.length != 0) {
      let switchedData = await this.getSelectedSwitchedCRD(this.state.idsList);
      let redefinedSwitchedData = this.redefinedData(
        this.formatSwitchDataToExport(switchedData),
        this.state.cdrSwitchedHeaders
      );

      zip.file("Switched.csv", this.createCsvFile(redefinedSwitchedData));
    }
    let callRecordsFiles = await this.downloadCdrFile(
      this.state.selectedCallRecordsId
    );
    let voicemailsFiles = await this.downloadCdrVoicemailFile(
      this.state.selectedVoiceMailsId
    );

    zip.file("CDR.csv", this.createCsvFile(data));
    zip.file("callRecords.zip", callRecordsFiles);
    zip.file("voicemails.zip", voicemailsFiles);
    zip.generateAsync({ type: "blob" }).then(function (content) {
      saveAs(content, name);
    });
  };
  createCsvFile(data) {
    let csvContent = "";

    data.forEach((row) => {
      csvContent += row.join(",") + "\n";
    });

    const cdrBlob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8,",
    });
    return cdrBlob;
  }
  createCsvFileDataNoSwitched(data, name) {
    let csvContent = "";
    data.forEach((row) => {
      csvContent += row.join(",") + "\n";
    });

    const cdrBlob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8,",
    });
    const Url = URL.createObjectURL(cdrBlob);
    var a = window.document.createElement("a");
    a.href = Url;
    a.download = name;

    // Append anchor to body.
    document.body.appendChild(a);
    a.click();

    // Remove anchor from body
    document.body.removeChild(a);
  }

  // createDataWithFiles(data) {
  //   let csvContent = "";

  //   data.forEach((row) => {
  //     csvContent += row.join(",") + "\n";
  //   });

  //   const cdrBlob = new Blob([csvContent], {
  //     type: "text/csv;charset=utf-8,",
  //   });

  //   return cdrBlob;
  // }

  formatDataToExport(selectedRows) {
    let dataArray = [];
    Object.values(selectedRows).forEach((data) => {
      let rowObject = {};
      rowObject.cdrId = data.cdrId;
      rowObject.a = data.a;
      rowObject.customerName =
        data.customerName == "---" ? null : data.customerName;
      rowObject.b = data.b;
      rowObject.callRecord =
        data.isSwitched == "true" && data.callResult == "ANSWERED_BY_AGENT"
          ? data.cdrId
          : null;
      rowObject.voicemail = data.hasVoiceMail ? data.cdrId : null;
      rowObject.startTime = data.startTime;
      rowObject.endTime = data.endTime;
      rowObject.switchTime = data.switchTime == "---" ? null : data.switchTime;
      rowObject.callResult = data.callResult;
      rowObject.callDuration = data.callDuration;
      rowObject.callDirection = data.callDirection;

      dataArray.push(rowObject);
    });

    return dataArray;
  }

  formatSwitchDataToExport(selectedRows) {
    let dataArray = [];

    Object.values(selectedRows).forEach((data) => {
      let rowObject = {};
      rowObject.cdrId = data.cdrId;
      rowObject.username = data.username;
      rowObject.switchTime = data.switchTime == "---" ? null : data.switchTime;
      rowObject.switchingStatus = data.switchingStatus;
      rowObject.callStatus = data.callStatus;
      rowObject.answerTime = data.answerTime;
      rowObject.endTime = data.endTime;
      dataArray.push(rowObject);
    });

    return dataArray;
  }

  redefinedData(data, headers) {
    let dataArray = [];
    dataArray.push(headers);
    data.forEach((item) => {
      dataArray.push(Object.values(item));
    });
    return dataArray;
  }
  showModalContent = (e) => {
    this.setState({
      operationKey: e.key,
      showModal: true,
    });
  };
  getExportFileName = (e) => {
    this.setState({ fileName: e.target.value });
    e.target.value = "";
  };

  isExpiredWithStartOfDay(startTime) {
    let expirationDate = moment().subtract(5, 'days');
    let startTimeMoment = moment(startTime, 'DD-MM-YYYY HH:mm:ss', true).startOf("day");
    expirationDate = expirationDate.startOf("day");
    return startTimeMoment.isSameOrBefore(expirationDate);
  }

  isExpiredWithExactTime(startTime) {
    let expirationDate = moment().subtract(3, 'days');
    let startTimeMoment = moment(startTime, 'DD-MM-YYYY HH:mm:ss', true);
    return startTimeMoment.isSameOrBefore(expirationDate);
  }

  render() {
    let { isFetching, isSelected } = this.state;

    const columns = [
      {
        title: i18next.t("A number"),
        dataIndex: "a",
        key: "a",
        ...this.getColumnSearchProps("a"),
        render: (text) =>
          this.state.searchedColumn === "a" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("Customer name"),
        dataIndex: "customerName",
        key: "customerName",
        ...this.getColumnSearchProps("customerName"),
        render: (text) =>
          this.state.searchedColumn === "customerName" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("B number"),
        dataIndex: "b",
        key: "b",
        ...this.getColumnSearchProps("b"),
        render: (text) =>
          this.state.searchedColumn === "b" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("Call Record"),
        dataIndex: "callRecord",
        key: "callRecord",
        render: (text, record) =>
          record.isSwitched === "true" &&
            record.callResult === "ANSWERED_BY_AGENT" ? (
            this.isExpiredWithStartOfDay(record.startTime) && this.constants.enableCallRecordExpiration
              ? <AudioPlayer record={record} type="record" disabled={true} />
              : <AudioPlayer record={record} type="record" />
          ) : (
            "---"
          ),
      },
      {
        title: i18next.t("Voicemail"),
        dataIndex: "voicemail",
        key: "voicemail",
        render: (text, record) =>
          record.hasVoiceMail ? (
            this.isExpiredWithStartOfDay(record.startTime) && this.constants.enableVoiceMailExpiration 
              ? <AudioPlayer record={record} type="voiceMail" disabled={true} />
              : <AudioPlayer record={record} type="voiceMail" />
          ) : (
            "---"
          ),
        // record.callResult === "ANSWERED_VOICEMAIL" ? (
        //   <AudioPlayer record={record} type="voiceMail" />
        // ) : (
        //   "---"
        // ),
      },
      {
        title: i18next.t("Start time"),
        dataIndex: "startTime",
        key: "startTime",
      },
      { title: i18next.t("End time"), dataIndex: "endTime", key: "endTime" },
      //{ title: "Is Switched", dataIndex: "isSwitched", key: "isSwitched" },
      {
        title: i18next.t("Switched Time"),
        dataIndex: "switchTime",
        key: "switchTime",
      },
      {
        title: i18next.t("Call result"),
        dataIndex: "callResult",
        key: "callResult",
        ...this.getColumnSearchProps("callResult"),
        render: (text) =>
          this.state.searchedColumn === "callResult" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("Call duration"),
        dataIndex: "callDuration",
        key: "callDuration",
      },
      {
        title: i18next.t("Call direction"),
        dataIndex: "callDirection",
        key: "callDirection",
        ...this.getColumnSearchProps("callDirection"),
        render: (text) =>
          this.state.searchedColumn === "callDirection" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
    ];

    const menu = (
      <Menu onClick={(e) => this.showModalContent(e)}>
        <Menu.Item key="1"> {i18next.t("Data only")} </Menu.Item>
        <Menu.Item key="2"> {i18next.t("Data with files")} </Menu.Item>
      </Menu>
    );
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRows.length != 0 ? (isSelected = true) : (isSelected = false);

        let idsList = [];
        let callRecordIds = [];
        let voiceMailsIds = [];

        selectedRows.forEach((el) => {
          if (el.isSwitched == "true") idsList.push(el.cdrId);
          if (el.isSwitched == "true" && el.callResult === "ANSWERED_BY_AGENT" && !el.isExpired)
            callRecordIds.push(el.cdrId);

          if (el.hasVoiceMail) {
            if (this.constants.enableVoiceMailExpiration) {
              if(!el.isExpired) voiceMailsIds.push(el.cdrId);
            } else {
              voiceMailsIds.push(el.cdrId);
            }
          };
          // if (el.callResult === "ANSWERED_VOICEMAIL")
          //   voiceMailsIds.push(el.cdrId);

        });

        //format selected rows and put it in array
        let data = this.formatDataToExport(selectedRows, columns);
        this.setState({
          isSelected,
          selectedData: data,
          idsList: idsList,
          selectedCallRecordsId: callRecordIds,
          selectedVoiceMailsId: voiceMailsIds,
        });
      },
    };

    return (
      <Translation>
        {(t) => (
          <Page title={t("CDR Table")}>
            <Row
              style={{
                marginTop: "30px",
                marginBottom: "8px",
                alignItems: "center",
                fontSize: "18px",
              }}
            >
              <Col xs={{ span: 24 }} lg={{ span: 12 }}>
                <RangePicker
                  showTime={true}
                  format={"YYYY-MM-DD HH:mm:ss"}
                  onChange={(e) => {
                    if (e.length <= 0) this.getAllCdrs();
                  }}
                  onOk={(e) => this.onOk(e)}
                  placeholder={[i18next.t("from"), i18next.t("to")]}
                  defaultValue={[
                    moment().startOf("day"),
                    moment().endOf("day"),
                  ]}
                  locale={this.state.lang === "ar" ? ar : en}
                />
                {/* <Alert
      description="Please note that call records expire after 5 days."
      type="error"
      closable
      // onClose={()=>{console.log("close")}}
      style={{marginTop:5}}
    /> */}
                <Text style={{ margin: 5, color: "#d73a31", fontSize: 16 }}>
                  {t("Please note that call records expire after 5 days.")}
                </Text>
              </Col>
              <Dropdown
                overlay={menu}
                disabled={this.state.data.length != 0 ? false : true}
              >
                <Button
                  className="button-submit"
                  type="primary"
                  size="default"
                  loading={this.state.isExporting}
                >
                  {this.state.isSelected
                    ? t("Export Selected")
                    : t("Export All")}{" "}
                  <Icon type="download" />
                </Button>
              </Dropdown>
            </Row>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>

                <Table
                  className="components-table-demo-nested"
                  columns={columns}
                  expandedRowRender={(record) => (
                    <CDRSwitchedCalls
                      record={record}
                      from={this.state.from}
                      to={this.state.to}
                    />
                  )}
                  rowSelection={rowSelection}
                  expandIcon={(props) => this.customExpandIcon(props)}
                  dataSource={this.state.data}
                  bordered
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </div>
            )}
            <Modal
              title={
                this.state.operationKey == 1
                  ? t(" Confirm Exproting Data")
                  : t(" Confirm Exporting Data With Files")
              }
              visible={this.state.showModal}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
              okText={t("OK")}
              cancelText={t("Cancel")}
            >
              <Form.Item
                label={t("File Name")}
                labelCol={{ span: 4 }}
                wrapperCol={{
                  span: 18,
                }}
              >
                <Input
                  id="filename"
                  onChange={this.getExportFileName}
                  style={{ marginLeft: 10 }}
                ></Input>
              </Form.Item>
            </Modal>
          </Page>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(CDRTable);
